import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Aligner } from '@alfa-bank/site-aligner';
import { Text } from '@alfa-bank/site-text-v2';
import { Link } from '@alfa-bank/site-link';

import { CodeInputFieldDesktop as CodeInputField } from '../../../components/code-input-field/desktop/desktop';
import { SmsLayout as Component } from '../sms-layout';
import type { TSmsLayout, IDeps } from '../models';

import styles from './desktop.css';

export const SmsLayoutDesktop = createWidget<IDeps, TSmsLayout>({
    Aligner,
    CodeInputField,
    Text,
    Link,
    isMobile: false,
    styles,
})(Component);
